import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
﻿export const dataStatus = [
  {
    value: true,
    label: t("Hoạt động", "Hoạt động")
  },
  {
    value: false,
    label: t("Không hoạt động", "Không hoạt động")
  }
]

export enum StatusEum {
  SAVE_DRAFT = 1,
  WAIT_APPROVE = 2,
  APPROVED = 3,
  REFUSE = 4,
  PUBLISHED = 5,
  END = 6,
}
export enum ApprovalStatusEnum {
  WAIT_APPROVE = 1,
  APPROVED = 2,
  REFUSE = 3,
  REVOKE = 4,
}
export enum CoursePlanStatus {
  SAVE_DRAFT = 1,
  WAIT_APPROVE = 2,
  APPROVED = 3,
  REFUSE = 4,
}
export const surveyStatus = [
  {
    value: 'published',
    label: t("Đã xuất bản", "Đã xuất bản")
  },
  {
    value: 'draft',
    label: t("Bản nháp", "Bản nháp")
  },
  {
    value: 'waitConfirm',
    label: t("Chờ duyệt", "Chờ duyệt")
  },
  {
    value: 'ended',
    label: t("Kết thúc", "Kết thúc")
  },
]

export const surveyType = [
  {
    value: 'self',
    label: t("Tự triển khai", "Tự triển khai")
  },
  {
    value: 'coop',
    label: t("Hợp tác xây dựng", "Hợp tác xây dựng")
  },
]


export const validateFormCreate = ['surveyName', 'forDepartment', 'surveyStatus', 'surveyType', 'createdAt', 'publishedAt', 'userCreate']

export const validateFieldFilter = ['surveyStatus', 'surveyType', 'createdAt', 'publishedAt']

